export enum UserFilterType {
    Requests = 1,
    Activities = 2
}
